export class Language {
    constructor(
        public id: number,
        public name: string
    ){}
}


